import { updateItems } from '@/mocks/home';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-3xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-secondary-600 mb-2">实时动态</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="text-foreground-500 text-sm mt-3">关注爱看影院的最新更新与平台公告</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-1">
            {updateItems.map((item) => {
              const dotColor = item.tagColor === 'primary' ? 'bg-primary-500' : item.tagColor === 'secondary' ? 'bg-secondary-500' : 'bg-accent-500';
              const tagBg = item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' : item.tagColor === 'secondary' ? 'bg-secondary-100 text-secondary-700' : 'bg-accent-100 text-accent-700';
              return (
                <div key={item.id} className="flex items-start gap-4 pl-1 py-3">
                  <div className={`w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0 ${dotColor} relative z-10 ring-4 ring-background-50`}></div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagBg} whitespace-nowrap`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}